import React from 'react';
import {goRoute} from '../common/js'
import util from "../../util/tools";
import commonTools from "../../../common/util/util";
import Header from "../common/Header";
import ActivityPopup from '../common/ActivityPopup'
import './index.css';

export default class Home extends React.Component {
    constructor() {
        super();
        this.state = {
            curTitle: "排行",
            page: 1,
            currentNav:137,//137 男生 138 女生 139 出版
            data2:[],
            isLoad:false,
            showPopup: false,
            popupId: null,
            activityUrl: '',
            activityId: ''
        };
    }

    componentDidMount() {
        document.title = this.state.curTitle;
        
        let str = commonTools.searchPar()
        console.log(str)
        let currentNav = 137;//男频
        if(commonTools.cnzzData.property == 2){
            currentNav = 138;//女频
        }
        this.setState({
            currentNav: str.type || currentNav
        },()=>{
            this.result()
        })
        if (!str.isChange) {
            this.checkPopup()
        }
    }
    option(obj) {
        let result = '';
        let item;
        for (item in obj) {
            result += '&' + item + '=' + obj[item];
        }
        if (result) {
            result = result.slice(1);
        }
        return result;
    }
    changeData(index){
        let url = document.location.href
        if(url.includes('?')){
            let str = commonTools.searchPar(url)
            str.isChange = '1'
            if(!!str.type){
                str.type = index
                let option = this.option(str)
                url=`/rank?${option}`
            }else {
                str.type = index
                let option = this.option(str)
                url = `rank?${option}`
            }

        }else {
            url = `/rank?type=${index}&isChange=1`
        }
        this.props.history.push(`${url}`)
        this.setState({
            page: 1,
            currentNav: index,
            data2:[],
            isLoad:false
        },()=>{
            this.result()
        })
    }

    result(){
        let num = 30;
        util.ajax({
            url: "/zh/book/ranking",
            isUser: true,
            isWechatId: true,
            data: {
                num: num,
                page:this.state.page,
                re_cid: this.state.currentNav
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    let temp = {
                        isLoad: false,
                        data2: this.state.data2.concat(json)
                    };
                    if(json.length == num || this.state.page == 1){
                        // 还未到最后一页
                        temp.isLoad = true;
                        temp.page = parseInt(this.state.page) + 1;
                    }else{
                        temp.isLoad = false;
                    }
                    this.setState(temp)
                }
            }
        });
    }

    // 判断是否有活动弹窗
    checkPopup() {
        const date = new Date()
        const fullYear = date.getFullYear()
        const month = date.getMonth()
        const day = date.getDate()
        const fullDate = `${fullYear}-${month+1}-${day}`
        const oldDate = localStorage.popupDate7
        util.ajax({
            url: '/zh/activity/activitypopup',
            data:{
                popup_id: 7
            },
            callback: res => {
                // console.log(res)
                if (res.result.status.code == 0 && res.result.data.length) {
                    const data = res.result.data[0]
                    this.setState({
                        popupId: data.temp_id,
                        activityUrl: data.activity_url,
                        activityId: data.id
                    })
                    if (!oldDate) {
                        this.setState({
                            showPopup: true
                        })
                        localStorage.popupDate7 = fullDate
                    } else if (oldDate && fullDate != oldDate ) {
                        this.setState({
                            showPopup: true
                        })
                        localStorage.popupDate7 = fullDate
                    } else {
                        this.setState({
                            showPopup: false
                        })
                    }
                }
            }
        })
    }

    // 关闭弹窗
    closePopup = () => {
        this.setState({
            showPopup: false
        })
    }

    render() {
        //138 女生 139 出版 137 男生
        return (
            <div className='rank'>
                <Header />
                <div className='module1'>
                    <div className='tab'>
                        <div className={`tab_single ${this.state.currentNav==138 && 'tab_singleColor'}`} onClick={()=>this.changeData(138)}>女生</div>
                        <div className={`tab_single ${this.state.currentNav==137 && 'tab_singleColor'}`} onClick={()=>this.changeData(137)}>男生</div>
                        {/* <div className={`tab_single ${this.state.currentNav==139 && 'tab_singleColor'}`} onClick={()=>this.changeData(139)}>出版</div> */}
                    </div>
                    <div className='books1'>
                        <div className='books1_singleOut'>
                            {
                                !!this.state.data2 && this.state.data2.length>0 && this.state.data2.map((item,index) => {
                                    if(index<3){
                                        return  <div className='books1_single' key={`b_${index}`} onClick={()=>goRoute(this.props,item.book_id,0)}>
                                            <img className='books1_single_pic' src={item.cover_url}/>
                                            <div className='books1_single_name text-overflow'>{item.book_title}</div>
                                            <div className='books1_single_author text-overflow'>{item.author_name}</div>
                                            <div className='books1_single_rank'>{parseInt(index)+1}</div>
                                        </div>
                                    }
                                })
                            }
                        </div>
                        <div className='books1_singleNextOut' >
                            {
                                !!this.state.data2 && this.state.data2.length>0 && this.state.data2.map((item,index) => {
                                    if(index>2){
                                        return <div className='books1_singleNext' key={`c_${index}`} onClick={()=>goRoute(this.props,item.book_id,0)}>
                                            <span className='books1_singleNext_rank'>{index+1}.</span>
                                            <span className='books1_singleNext_type'>{!!item.category_info.category_1.short_name?item.category_info.category_1.short_name:'其他'}</span>
                                            <span className='books1_singleNext_name text-overflow'>{item.book_title}</span>
                                            <span className='books1_singleNext_author text-overflow'>{item.author_name}</span>
                                        </div>
                                    }
                                })
                            }
                        </div>
                    </div>
                </div>
                {
                    this.state.showPopup &&
                    <ActivityPopup
                        popupId={this.state.popupId} activityUrl={this.state.activityUrl}
                        activityId={this.state.activityId} closePopup={this.closePopup}>
                    </ActivityPopup>
                }
            </div>
        );
    }
}